/**
 * Hình thức sổ kế toán
 */
export default {
  // Summary: 3,
  SharedDiary: 0,
  LedgerDiary: 1,
  LicenseRecord: 2,
};
